
export default () => ({
  user: {
    id: null,
    fullname: null,
    image: null,
    phone: null,
    email: null,
    role: {
      id: null,
      name: null
    }
  },
  agency: {
    name: null,
    legalName: null,
    inn: null,
    bik: null,
    kpp: null,
    address: null,
    legalAddress: null,
    phone: null,
    email: null,
    country: null
  }
})
